module.exports = "<span class='tag'\n    [class.selected]=\"isSelected\"\n    [class.excluded]=\"isExcluded\"\n    (click)='switch($event)'>\n  {{label}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-filter/tag-filter.component.html
// module id = ../../../../../src/app/tag-filter/tag-filter.component.html
// module chunks = main